import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "year-filter" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "year-filter__ending" }, " год ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_ArrowDown = _resolveComponent("ArrowDown")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dropdown, {
      type: "primary",
      modelValue: _ctx.selectedYear,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedYear) = $event)),
      trigger: "click"
    }, {
      dropdown: _withCtx(() => [
        _createVNode(_component_el_tooltip, {
          visible: _ctx.noDataTooltipState,
          content: "Отчёт станет доступным после 1 февраля",
          placement: "right-start",
          effect: "light"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_dropdown_menu, {
              style: {"width":"100%"},
              ref: "dropdownMenu"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableYears, (year) => {
                  return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                    key: year.value,
                    onClick: ($event: any) => (_ctx.handleYearSelection(year.value)),
                    disabled: year.disabled,
                    class: _normalizeClass({
              'year-filter__not-yet-data': year.disabled
            }),
                    onMouseenter: ($event: any) => (_ctx.noDataTooltipState = year.disabled),
                    onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (_ctx.noDataTooltipState = false))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(year.value), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick", "disabled", "class", "onMouseenter"]))
                }), 128))
              ]),
              _: 1
            }, 512)
          ]),
          _: 1
        }, 8, ["visible"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          class: "year-filter__button"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, {
              size: "small",
              style: {"margin-right":"0.625rem"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Calendar)
              ]),
              _: 1
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.selectedYear) + " ", 1),
            _createVNode(_component_el_icon, { class: "el-icon--right" }, {
              default: _withCtx(() => [
                _createVNode(_component_ArrowDown)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _hoisted_2
  ]))
}